/* Publish by EComposer at 2026-10-08 18:29:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4mhqstxn8qp"]=  window.__ectimmers["ecom-4mhqstxn8qp"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4mhqstxn8qp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mhqstxn8qp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvg3d4umc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvg3d4umc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t7dqzoz7hus').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t7dqzoz7hus', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rte4na2htki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rte4na2htki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bebatobpcru').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bebatobpcru', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffre9i3xw86').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffre9i3xw86', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx99qfxe9di').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx99qfxe9di', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2oqr1qkbepr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2oqr1qkbepr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwlv66smyy9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwlv66smyy9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bw1xlpmyfq4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bw1xlpmyfq4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-793bs8yoj5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-793bs8yoj5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4sbgow6uu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4sbgow6uu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8o4zulbuvp7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8o4zulbuvp7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwcustrwrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwcustrwrg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22pfj2jtsxch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22pfj2jtsxch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wq9qr12hwoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wq9qr12hwoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-welhymeyvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-welhymeyvt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nlkp99zrjx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nlkp99zrjx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ou064xb99j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ou064xb99j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rik4qwgsho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rik4qwgsho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vpt993cbn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vpt993cbn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2ok0628j4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2ok0628j4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ftqaesmuanw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ftqaesmuanw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xz85c0s5af').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xz85c0s5af', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4txs6eb0wih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4txs6eb0wih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1o3311za4k1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1o3311za4k1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tadytsoicvm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tadytsoicvm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmuh9j32rkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmuh9j32rkg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34mq4itqs7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34mq4itqs7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdplwahfegc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdplwahfegc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6kucul073c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6kucul073c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjzc8wapytd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjzc8wapytd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uo87ql1sicn"]=  window.__ectimmers["ecom-uo87ql1sicn"] || {};
const t=this.$el;if(!t)return;let i=this.settings.link_redirect,s=this.settings.redirect,p=this.settings.gtag_event_name,_=this.settings.gtag_form_name,c=this.settings.hide_form_when_submit||!1,l=t.querySelector('.ecom-contact-form-file[type="file"]');const h=this.id,o=t.querySelector("#ecom-contact-form-"+h);function k(){if(window.location.href.includes("contact_posted=true")){if(p&&(typeof window.gtag=="function"&&window.gtag("event",p,{form_name:_||"",form_id:o?o.id:""}),window.dataLayer=window.dataLayer||[],window.dataLayer.push({event:p,formName:_||""})),s!=="popup"&&i&&i.href){let n=i.href;if(n=="")return!1;i.target==="_blank"?window.open(n):window.location.href=n}if(c){const n=t.querySelector(".ecom__contact-form-content");n&&(n.style.display="none")}if(o&&o.hasAttribute("data-ecom-popup")){const n=o.getAttribute("data-ecom-popup")||"",m=document.querySelector("#ecom-popup-data");if(!m){console.warn("Ecom popup data element not found");return}const g=JSON.parse(m.innerHTML);if(g){let u=g.find(T=>T.id===n);setTimeout(()=>{u&&window.EComPopup.popupContainerHandler&&window.EComPopup.popupContainerHandler(u)},300)}}}}if(k(),window.location.href.includes(c),!o)return;const b=o.querySelector(".ecom__form-button");if(!b)return;l&&(o.setAttribute("enctype","multipart/form-data"),o.addEventListener("submit",function(w){if(!l.value||l.value==="")return;w.preventDefault(),w.stopImmediatePropagation(),b.classList.add("ecom-ajax-loading","ecom-loading");const n=o.querySelector('input[type="file"]');let m=new FormData,g=window.location.origin,u=window.EComposer&&window.EComposer.proxy_path;const T=`${g}${u}/contact-form`;m.append("file",n.files[0]),n.value&&u&&fetch(T,{method:"POST",body:m}).then(f=>f.json()).then(f=>{if(f.status==="success"){let E=n.name;n.remove();let e=document.createElement("input");e.value=f.src_file,e.type="hidden",e.name=E,o.appendChild(e),o.submit()}else alert(`Notice: ${f.message}`)}).catch(f=>console.error(f)).finally(function(){b.classList.remove("ecom-ajax-loading","ecom-loading")})}),l.addEventListener("change",function(){this.files[0].size>10485760&&(this.value="",alert("File size exceeds the maximum allowed limit (10MB)."))}));let S=t.querySelectorAll(".ecom-required--checkbox");b.addEventListener("click",function(w){S.length>0&&S.forEach(function(n){let m=n.querySelectorAll("input[type=checkbox]");if(m.length==0)return;let g=!1;m.forEach(function(u){u.checked&&(g=!0)}),g?m.forEach(function(u){u.required=!1}):m.forEach(function(u){u.required=!0})})}),o.dataset.ecTrackingId&&o.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:o.id,tracking_id:o.dataset.ecTrackingId})},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-uo87ql1sicn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uo87ql1sicn', settings: {"gtag_event_name":"formSubmissionSuccess","gtag_form_name":"ContactForm"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}